import { atom } from 'jotai'
import { TPeriod } from '../types/period.type'

export const periodState = atom<TPeriod>({
    success: false,
    country: '',
    system: '',
    date: '',
    entryPeriod: '',
    message4nonAB: [],
    isTopup: false,
    message: [],
    autoshipPeriod: [],
    autoshipPeriodJP4Edit: {
        period: '',
        english: '',
        native: ''
    },
    isForceTopup: false
})

export const loadingPeriodState = atom<boolean>(false)
